module.exports = __webpack_public_path__ + "img/logo.267a370.svg";